var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "institutions" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c("Search", {
            attrs: {
              model: _vm.search,
              elem: _vm.searchElem,
              "btn-loading": _vm.list.loading,
            },
            on: { "on-search": _vm.handleDataList },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "extra" }, slot: "extra" },
        [
          _c(
            "Button",
            {
              attrs: { icon: "md-add", type: "primary" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v("添加")]
          ),
        ],
        1
      ),
      _c("ITable", {
        ref: "list",
        attrs: {
          stripe: "",
          columns: _vm.columns,
          loading: _vm.list.loading,
          data: _vm.list.data,
          total: _vm.list.total,
        },
        on: {
          "on-page-change": _vm.handleDataList,
          "on-selection-change": _vm.handleSelectionChange,
        },
      }),
      _c("InstitutionEdit", {
        ref: "edit",
        on: { "on-update": _vm.handleDataList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }